export default __webpack_public_path__ + "static/media/Carla Flatcher.28eec764.png";